document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".home-collections-swiper").forEach((swiperEl) => {
    const productsContainer = swiperEl.closest(".carousel-collections__products");
    const nextButton = productsContainer?.querySelector(".swiper-button-next");
    const prevButton = productsContainer?.querySelector(".swiper-button-prev");

    new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        900: {
          slidesPerView: 4,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 20
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 24
        }
      }
    });
  });
});
